import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';

const bullets = [
  'Prompt, friendly, local service',
  'Free, no-obligation quotes',
  'Experienced, fully insured',
  'Satisfaction guaranteed',
];

const WhyChooseUs = () => {
  return (
    <section className="section why">
      <div className="container">
        <h2 className="section-title">Why Choose Us</h2>
        <div className="why-grid">
          {bullets.map((b) => (
            <div className="why-item" key={b}>
              <FaCheckCircle color="var(--green-500)" size={20} />
              <div><strong>{b}</strong></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;


